<template>
  <div class="CustomeServicePopup" v-show="isPopupShow">
    <div class="customer-popup-box">
      <div class="customer-popup-title">识别此二维码添加{{csPopupMsg.name}}</div>
      <img :src="csPopupMsg.qrcode">
      <div 
        class="close-popup"
        @click="close"
        >确定</div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      v-show="isPopupShow"
      @click="close"
    ></div>
  </div>
</template>

<script>
export default {
  name: "CustomeServicePopup",
  props: {
    isPopupShow:{
      type:Boolean,
      default:false
    },
    csPopupMsg:{
      type:Object
    }
  },
  data() {
    return {};
  },
  methods: {
    close: function() {
      this.$emit("closePrePopup", false);
    }
  }
};
</script>

<style scoped>
.CustomeServicePopup .customer-popup-box{
  position: fixed;
  width: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  text-align: center;
  background: #fff;
  border-radius: .2rem;
  padding-top: .7rem;
}
.CustomeServicePopup .customer-popup-box img{
  width: 200px;
}
.CustomeServicePopup .customer-popup-title{
  font-size: .34rem;
  font-weight: 500;
  padding-bottom: .32rem;
}
.CustomeServicePopup .close-popup{
  margin-top: .6rem;
  padding: .4rem 0;
  font-size: .32rem;
  border-top: .02rem solid #e4e4e4;
  color: #576B95;
  font-weight: 700;
}
</style>
